import Box from '@mui/material/Box';
import React from 'react';

import { styles } from './Pointer.styles';

export const Pointer = () => {
  return <Box sx={styles.pointer} />;
};
